<template>
  <div class="hc-no-data-box">
    <img width="240" height="165" :src="quePngUrl" />
    <div style="color: #919499">{{msg}}</div>
  </div>
</template>

<script>
import quePngUrl from '@/../static/images/que.png'
export default {
  name: 'HcNoData',
  components: {
  },
  props: {
    msg: {
      type: String,
      default: '暂无数据',
    }
  },
  data() {
    return {
      quePngUrl
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.hc-no-data-box{
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>
